import { FC } from 'react';
import { useSession } from '@nextgen-web-framework/all';
import { type ProductIdAndSizeComponentPropsTypes } from './types/propsTypes';
import styles from './ProductIdAndSizeComponent.module.scss';
import { IdAndSizeType } from './types/enums';

const ProductIdAndSizeComponent: FC<ProductIdAndSizeComponentPropsTypes> = ({
  productId,
  productSize,
  prefixText = '',
  idSizeType,
  showProductId = false,
}: ProductIdAndSizeComponentPropsTypes): JSX.Element => {
  const { isABO } = useSession();
  const displayProductID = (showProductId || isABO()) && !!productId;
  const displaySize = !!productSize;

  const IdSizeClassName = () => {
    if (!displayProductID && !displaySize) {
      return 'product-id-and-size-container-displayNone';
    }

    switch (idSizeType) {
      case IdAndSizeType.IDSIZECHECKOUT:
        return 'product-id-and-size-container-checkout';
      case IdAndSizeType.IDSIZEPRODUCTCARD:
        return 'product-id-and-size-container-productCard';
      case IdAndSizeType.IDSIZECART:
        return 'product-id-and-size-container-cart';
      case IdAndSizeType.IDSIZEPRODUCTMERCHANDISE:
        return 'product-id-and-size-container-merchandise';
      case IdAndSizeType.IDSIZEPROMOTION:
        return 'product-id-and-size-container-promotion';
      case IdAndSizeType.ID_SIZE_VARIANT_DRAWER:
        return 'product-id-and-size-container-variant-drawer';
      case IdAndSizeType.IDSIZESEARCHCARD:
        return 'product-id-and-size-container-search';
      case IdAndSizeType.IDSIZEDISPLAYNONE:
        return 'product-id-and-size-container-displayNone';
      case IdAndSizeType.ID_SIZE_APOINT_CARD:
        return 'product-id-and-size-container-apoint-card';
      case IdAndSizeType.ID_SIZE_FREE_CART_CARD:
        return 'product-id-and-size-free-cart-card';
      case IdAndSizeType.ID_SIZE_CART_MOBILE_VARIANT:
        return 'product-id-and-size-container-cart-mobile-view-force';
      default:
        return 'product-id-and-size-container';
    }
  };

  return (
    <h3 className={styles[IdSizeClassName()]} data-testid={IdSizeClassName()}>
      {displayProductID && (
        <span className={styles['product-id']} data-testid="product-id-test-id">{`${prefixText} ${productId}`}</span>
      )}
      {displaySize && (
        <span className={styles['product-size']} data-testid="product-size-test-id">
          {productSize}
        </span>
      )}
    </h3>
  );
};

export default ProductIdAndSizeComponent;
export type { ProductIdAndSizeComponentPropsTypes };
export { IdAndSizeType };
